import { getMaltaOfferedCourseCertificationEqualization } from "@/src/constants/AdmissionOffice/Malta/maltaOfferedCourseCertificationConfig";
import type { MaltaOfferedCourseEntry } from "@/src/constants/AdmissionOffice/Malta/maltaOfferedCoursesConfig";
import { normalizeAdmissionSemesterValue } from "@/src/constants/AdmissionOffice/admissionSemesterOptions";

export interface MaltaOfferedCourseFormValues {
  category?: string;
  admissionSemester?: string;
  duration?: string;
  tuitionFee?: string;
  medicalInsurance?: string;
  transfer?: string;
  certificationEqualization?: string;
  tuitionFeeVisible?: boolean;
  medicalInsuranceVisible?: boolean;
  transferVisible?: boolean;
  certificationEqualizationVisible?: boolean;
}

type SetMaltaOfferedCourseFormValue = (
  name: keyof MaltaOfferedCourseFormValues,
  value: string | boolean,
  options?: { shouldDirty?: boolean },
) => void;

export const applyMaltaOfferedCourseCertificationEqualization = (
  courseLabel: string | undefined,
  setValue: SetMaltaOfferedCourseFormValue,
) => {
  const certificationValue = courseLabel ? getMaltaOfferedCourseCertificationEqualization(courseLabel) : undefined;

  if (certificationValue) {
    setValue("certificationEqualization", certificationValue, { shouldDirty: false });
    setValue("certificationEqualizationVisible", true, { shouldDirty: false });
    return;
  }

  setValue("certificationEqualization", "", { shouldDirty: false });
  setValue("certificationEqualizationVisible", false, { shouldDirty: false });
};

export interface ApplyMaltaOfferedCourseSelectionOptions {
  /** When false, keeps task/user semester instead of overwriting from course template. */
  updateAdmissionSemester?: boolean;
}

export const applyMaltaOfferedCourseSelection = (
  entry: MaltaOfferedCourseEntry,
  setValue: SetMaltaOfferedCourseFormValue,
  options?: ApplyMaltaOfferedCourseSelectionOptions,
) => {
  const updateAdmissionSemester = options?.updateAdmissionSemester ?? true;

  setValue("category", entry.category, { shouldDirty: false });
  if (updateAdmissionSemester) {
    setValue("admissionSemester", normalizeAdmissionSemesterValue(entry.admissionSemester), { shouldDirty: false });
  }
  setValue("duration", entry.duration, { shouldDirty: false });
  setValue("tuitionFee", entry.tuitionFee, { shouldDirty: false });
  setValue("tuitionFeeVisible", true, { shouldDirty: false });

  setValue("medicalInsurance", entry.medicalInsurance, { shouldDirty: false });
  setValue("medicalInsuranceVisible", true, { shouldDirty: false });

  setValue("transfer", entry.transfer, { shouldDirty: false });
  setValue("transferVisible", true, { shouldDirty: false });

  applyMaltaOfferedCourseCertificationEqualization(entry.label, setValue);
};

export const clearMaltaOfferedCourseSelection = (setValue: SetMaltaOfferedCourseFormValue) => {
  setValue("category", "", { shouldDirty: false });
  setValue("admissionSemester", "", { shouldDirty: false });
  setValue("duration", "", { shouldDirty: false });
  setValue("tuitionFee", "", { shouldDirty: false });
  setValue("medicalInsurance", "", { shouldDirty: false });
  setValue("transfer", "", { shouldDirty: false });
  setValue("tuitionFeeVisible", true, { shouldDirty: false });
  setValue("medicalInsuranceVisible", true, { shouldDirty: false });
  setValue("transferVisible", true, { shouldDirty: false });
  applyMaltaOfferedCourseCertificationEqualization(undefined, setValue);
};
